import * as z from 'zod'

import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import * as validators from '@flows/configs/shared/validators'
import { createRefineDateSchema } from '@flows/configs/shared/validators'
import type { StepConfigParams } from '@flows/configs/types'
import { t } from '@flows/core/i18n'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { MAXIMUM_CUSTOMER_AGE, MINIMUM_CUSTOMER_AGE } from '@flows/insurance/constants'

const getErrorMap = (): z.ZodErrorMap => (issue, ctx) => {
  return (
    schemaUtils.bornOnErrorMap(issue, {
      min: 'sharedFlows_common:generic.errors.min_age',
      max: 'sharedFlows_common:generic.errors.max_age',
    }) ?? { message: ctx.defaultError }
  )
}

const pet_owner_birthday = (params: StepConfigParams) =>
  ({
    schema: z.object({
      born_on: validators.createPreprocessedDateSchema(
        createRefineDateSchema({
          minAge: {
            errorMessage: t('sharedFlows_common:generic.errors.min_age'),
            year: MINIMUM_CUSTOMER_AGE.de,
          },
          maxAge: {
            errorMessage: t('sharedFlows_common:generic.errors.max_age'),
            year: MAXIMUM_CUSTOMER_AGE.de,
          },
        })
      ),
    }),
    errorMap: getErrorMap(),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_owner_birthday.title',
        },
      },
      {
        type: 'date',
        shouldTrackValues: true,
        name: 'born_on',
        disabledIfValueExists: true,
      },
      {
        type: 'infoBox',
        showInfoIcon: true,
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_owner_birthday.infoBox.text',
        },
      },
    ],
    nextStep: 'pet_quote',
    subFlow: params.subFlow,
  }) as const satisfies AnyStepConfiguration

export default pet_owner_birthday
